import { get } from 'lodash'
import { warning } from '@/utils/alert'

/**
 * Flatten success responses body.
 *
 * @param response
 * @returns {*}
 */
export const success = response => get(response, 'data', {})

/**
 * Retornando as mensagens de erro da API no controller
 * Flatten error responses body.
 *
 * @param error
 * @returns {*}
 */
export const error = response => {
  const message = {
    data: get(response, 'response.data.data', {}),
    meta: get(response, 'response.data.meta', {})
  }

  // Mensagem de erro retorno API qualquer tipo de erro
  // ocazionando
  warning(message.meta.message)

  return Promise.reject(message)
}

/**
 * Default export.
 */
export default {
  success,
  error
}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors-n1/flatten.js